import useGetQuery from '_api/queries/useGetQuery';
import { ConstantsNameDescriptions } from '_api/types';

export const GET_PATIENT_RACE = 'get-patient-race';

export const useGetPatientRace = () =>
  useGetQuery<ConstantsNameDescriptions<string>[]>(
    () => `/constant/race`,
    {},
    [GET_PATIENT_RACE],
    {
      refetchOnWindowFocus: false,
    },
  );
